import z from "zod";

const BookWord = z.object({
	mistake_desciption: z
		.string()
		.describe(
			"Description of what was wrong in user usage of this word (e.g., misspelling, wrong context, native language word, etc.)"
		),
	correct_word: z.string().describe("The correct English word that should be used instead"),
	description: z
		.string()
		.describe(
			"Clear explanation of the word and word usage rules. Should NOT contain any mistake context - only describe the word itself and how to use it correctly."
		)
});

export const BookWordAnalysis = z.object({
	words: z
		.array(BookWord)
		.describe(
			"Array of words that are misspelled, used in wrong context, or typed in native language instead of English"
		)
});

export type IBookWordAnalysis = z.infer<typeof BookWordAnalysis>;
export type IBookWord = z.infer<typeof BookWord>;

const WordUsageResult = z.object({
	word: z.string().describe("The word being analyzed"),
	used_correctly: z
		.boolean()
		.describe("Whether the word was used correctly in the context of the user's message")
});

export const WordUsageAnalysis = z.object({
	correctly_used: z
		.array(WordUsageResult)
		.describe("Array of words that were used correctly in the user's message"),
	incorrectly_used: z
		.array(WordUsageResult)
		.describe("Array of words that were used incorrectly in the user's message")
});

export type IWordUsageAnalysis = z.infer<typeof WordUsageAnalysis>;
export type IWordUsageResult = z.infer<typeof WordUsageResult>;
